export const environment = {
	production: true,
	buildNumber: 1,
	environment: 'PROD',
	sentryEnabled: true,
	sentryNomeProgetto: '',
	sentryDsn: '',
	openTelemetryEnabled: true,
	openTelemetryApiUrl: 'https://monitoring.kedos-srl.it/collector',
	openTelemetryServiceName: 'angular-standalone',
	openTelemetryAttributes: 'service=angular-standalone,env=',
	apiUrl: 'https://ecommerce-api.pibgroupitalia.it/api/rest/',
	destinatatrioInvioEmailSegnalazioniErrore: 'segnalazioni@template.it',
	oggettoInvioEmailSegnalazioniErrore: 'Segnalazione errore applicativo',
	apiUsername: 'aicecommerce',
	apiPassword: 'aicecommercekedos',
};
